import axios from '@/plugins/axios';

export default {
    namespaced: true,

    state: {
        entities: [],
        entitiesCount: 0,
        entity: {}
    },

    mutations: {
        SET_ENTITIES(state, payload) {
            state.entities = payload;
        },
        SET_ENTITY(state, payload) {
            state.entity = payload;
        },
        CLEAR_ENTITY(state) {
            state.entity = {};
        },
    },

    actions: {
        async fetch({ commit }, { entity_id, entity_delivery_id }) {
            const { data } = await axios.get(`/admin/entities/${ entity_id }/deliveries/${ entity_delivery_id }/conditions`);
            commit('SET_ENTITIES', data);
            return data;
        },
        async get({ commit }, { entity_id, entity_delivery_id, id }) {
            const { data } = await axios.get(`/admin/entities/${ entity_id }/deliveries/${ entity_delivery_id }/conditions/${ id }`);
            commit('SET_ENTITY', data);
        },
        async save({ commit, state }, { entity_id, entity_delivery_id }) {
            let response = {};
            if(state.entity.id) {
                response = await axios.put(`/admin/entities/${ entity_id }/deliveries/${ entity_delivery_id }/conditions/${ state.entity.id }`, state.entity);
            } else {
                response = await axios.post(`/admin/entities/${ entity_id }/deliveries/${ entity_delivery_id }/conditions`, state.entity);
            }
            return response.data;
        },
        async delete({ commit }, { entity_id, entity_delivery_id, id }) {
            await axios.delete(`/admin/entities/${ entity_id }/deliveries/${ entity_delivery_id }/conditions/${ id }`);
        },
    },

    getters: {}
}
